// extracted by mini-css-extract-plugin
export default {"pageWrapper":"styles_pageWrapper__6TnLM"};